import { Typography } from 'antd';
import { useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import LookForEServiceCard from './LookForEServiceCard';
import type { IEservicesGroupModule } from '../types/eservices';
import { getFilterEServicesModules } from '../utils';

const { Text } = Typography;

interface LookForEServicesSearchEmptyResultsProps {
  allModules: IEservicesGroupModule[];
  searchInputValue: string;
}

const LookForEServicesSearchEmptyResults = ({
  allModules,
  searchInputValue,
}: LookForEServicesSearchEmptyResultsProps) => {
  const { t } = useTranslation('home');
  const popularModules = useMemo(() => getFilterEServicesModules({ allModules, isPopularModule: true }), [allModules]);

  return (
    <div className="flex flex-col gap-16 px-3 py-2 md:px-8 lg:p-0">
      <div className="flex flex-col items-center">
        <Trans
          components={{
            1: <Text className="text-xl" />,
            2: <span className="font-semibold text-primary-blue-grey" />,
            3: <span className="text-3xl font-semibold text-primary-blue-grey lg:text-5xl" />,
          }}
          i18nKey="searchResultsFoundFor"
          t={t}
          values={{ searchInputValue }}
        />
      </div>
      <div className="flex flex-col gap-6">
        <Text className="text-sm text-primary-blue-grey">{t('exploreOurPopularServices')}</Text>
        <div className="grid auto-rows-fr grid-cols-1 gap-2 lg:grid-cols-3 lg:gap-6">
          {popularModules.map(({ description, icon, label, onClick, publicDescription, publicUrl, url }) => (
            <LookForEServiceCard
              description={description}
              icon={icon}
              key={label}
              label={label}
              onClick={onClick}
              publicDescription={publicDescription}
              publicUrl={publicUrl}
              url={url}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default LookForEServicesSearchEmptyResults;
